import { render, staticRenderFns } from "./myorderList.vue?vue&type=template&id=f8e79c0e&"
import script from "./myorderList.vue?vue&type=script&lang=js&"
export * from "./myorderList.vue?vue&type=script&lang=js&"
import style0 from "./myorderList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports